import React from 'react'
import { remCss, scssVariables as variables } from 'src/helpers'

const ForwardIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '20' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={remCss(width)}
      height={remCss(width)}
      viewBox={'0 0 20 20'}
    >
      <path
        d="M11.3312 6.95388V4L16.5 9.16929L11.3312 14.3386V11.3182C9.76616 11.1952 8.1958 11.4775 6.77156 12.1379C5.34732 12.7984 4.11726 13.8147 3.2 15.0889C3.93397 11.3921 6.15211 7.69235 11.3312 6.95388Z"
        fill={fill}/>

    </svg>
  ),
)
ForwardIcon.displayName = 'ForwardIcon';

export default ForwardIcon
